export const DRIVEN_WHEELS_IDS = {}

export const DRIVEN_WHEELS = {}
